import { logError as sentryLogError } from '@/lib/error-logger.js';

function logError(error: Error | string | unknown, context?: Record<string, unknown>): void {
  sentryLogError(error, context);
}

export type SentryErrorLogger = typeof logError;

export function useErrorLogger(): SentryErrorLogger {
  return logError;
}
